import { CreditTableSearch } from "./screens/CreditTableSearch";
import { SendToCreditTable } from "./screens/SendToCreditTable";

// eslint-disable-next-line react-refresh/only-export-components
export const CreditTableScreens = {
  Search: CreditTableSearch,
  SendToCreditTable
};

export default CreditTableScreens;
